// Troféus para Rankings (canto inferior esquerdo do avatar)
import trofeuDouradoRnk from "../assets/img/trofeuDouradoRnk.png";
import trofeuPrataRnk from "../assets/img/trofeuPrataRnk.png";
import trofeuBronzeRnk from "../assets/img/trofeuBronzeRnk.png";

// Troféus para Posição do Usuário (ao lado da colocação)
import trofeuDouradoPsc from "../assets/img/trofeuDouradoPsc.png";
import trofeuPrataPsc from "../assets/img/trofeuPrataPsc.png";
import trofeuBronzePsc from "../assets/img/trofeuBronzePsc.png";

/**
 * Mapa de troféus para rankings (Rnk)
 * Usados no canto inferior esquerdo do avatar
 */
export const RANKING_TROPHIES = {
  1: trofeuDouradoRnk,
  2: trofeuPrataRnk,
  3: trofeuBronzeRnk,
} as const;

/**
 * Mapa de troféus para posição do usuário (Psc)
 * Usados ao lado direito da colocação
 */
export const POSITION_TROPHIES = {
  1: trofeuDouradoPsc,
  2: trofeuPrataPsc,
  3: trofeuBronzePsc,
} as const;

/**
 * Retorna o troféu de ranking para uma posição
 * @param position - Posição no ranking (1-3)
 * @returns URL do troféu ou null se não houver troféu para essa posição
 */
export function getRankingTrophy(position: number): string | null {
  if (position >= 1 && position <= 3) {
    return RANKING_TROPHIES[position as keyof typeof RANKING_TROPHIES];
  }
  return null;
}

/**
 * Retorna o troféu de posição para o componente UserPosition
 * @param position - Posição no ranking (1-3)
 * @returns URL do troféu ou null se não houver troféu para essa posição
 */
export function getPositionTrophy(position: number): string | null {
  if (position >= 1 && position <= 3) {
    return POSITION_TROPHIES[position as keyof typeof POSITION_TROPHIES];
  }
  return null;
}

/**
 * Verifica se uma posição tem troféu
 * @param position - Posição no ranking
 * @returns true se a posição tem troféu (1-3)
 */
export function hasTrophy(position: number): boolean {
  return position >= 1 && position <= 3;
}
